import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, map, Observable } from 'rxjs';
import { AccessToken } from 'src/app/oauth.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OutlookAuthService {
  private _tokenError = new BehaviorSubject<any>(null);
  tokenError = this._tokenError.asObservable();
  constructor(
    private http: HttpClient
  ) { }

  onTokenError(param) {
    this._tokenError.next(param);
  }

  /**
    * Gets access token in exchange of code
    * @param code 
    * @returns 
  */
  getAccessToken(code: string, params): Observable<AccessToken> {
    const { url, realm, outlookAuthEndpoint } = environment.keycloak;
    const body = new HttpParams()
      .set('grant_type', "authorization_code")
      .set('code', code)
      .set('redirect_uri', outlookAuthEndpoint)
      .set('client_id', localStorage.getItem("client_id") ? localStorage.getItem("client_id") : environment.keycloak.clientId)
      .set('client_secret', localStorage.getItem("client_secret") ? localStorage.getItem("client_secret") : environment.keycloak.clientSecret);
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    });

    return this.http
      .post<any>(`${url}/realms/${realm}/protocol/openid-connect/token`, body.toString(), { headers })
      .pipe(
        map(response => response)
      );
  }


  refreshAccessToken(code: string, params): Observable<AccessToken> {
    const { url, realm, outlookRefreshTokenEndpoint } = environment.keycloak;
    const body = new HttpParams()
      .set('grant_type', "refresh_token")
      .set('refresh_token', code)
      .set('redirect_uri', outlookRefreshTokenEndpoint)
      .set('client_id', params["client_id"] ? params["client_id"] : environment.keycloak.clientId)
      .set('client_secret', params["client_secret"] ? params["client_secret"] : environment.keycloak.clientSecret);
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    });

    return this.http
      .post<any>(`${url}/realms/${realm}/protocol/openid-connect/token`, body.toString(), { headers })
      .pipe(
        map(response => response)
      );
  }

  notifyTokenObtained(urlOrigin, body): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      // 'Access-Control-Allow-Origin': "http://tlf-napoli2-dev.eustema.intranet/euforlegal/teleforumweb",
      // 'Access-Control-Allow-Methods': "POST, GET, OPTIONS",
      // 'Access-Control-Allow-Headers': "Content-Type"
 
    });
    return this.http.post<any>(urlOrigin, body, {headers});
  }

  notifyTokenError(urlOrigin, param): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      // 'Access-Control-Allow-Origin': "http://tlf-napoli2-dev.eustema.intranet/euforlegal/teleforumweb",
      // 'Access-Control-Allow-Methods': "POST, GET, OPTIONS",
      // 'Access-Control-Allow-Headers': "Content-Type"
 
    });
    let url = `${urlOrigin}?error=${param}`;
    return this.http.get<any>(url, {headers});
  }
}
